import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";

function Header() {
  const [{ user }] = useStateValue();


  const login = () => {
    if (user) {
      auth.signOut();
    }
  };

  return (
    <nav className="header">
      {/* Logo left */}
      {/* <Link to ="/"> */}
      <a href="http://www.huronpines.com">
        <img
          className="header__logo"
          src="/logo512.png"
          alt=""
        />
      </a>
      {/* </Link> */}

      <div className='header__nav'>
      <Link to = {!user && "/login"} className="header__link">
          <div onClick={login} className="header__option">
            <span className="header__optionline1">
              {!user ? "" : user?.displayName}
            </span>
            <span className="header__optionline2">
              {user ? "Sign Out" : "Sign In"}
            </span>
          </div>
        </Link>
        <Link to ='/setup' className="header__link">
          <div className="header__option">
            <span className="header__optionline1">Game</span>
            <span className="header__optionline2">Setup</span>
          </div>
        </Link>
        <Link to ='/scoring' className="header__link">
          <div className="header__option">
            <span className="header__optionline1">Enter</span>
            <span className="header__optionline2">Scores</span>
          </div>
        </Link>
        <Link to ='/summary' className="header__link">
          <div className="header__option">
            <span className="header__optionline1">Score</span>
            <span className="header__optionline2">Summary</span>
          </div>
        </Link>
        {user.email==="docdatainc@gmail.com" &&
        <Link to ='/locations' className="header__link">
          <div className="header__option">
            <span className="header__optionline1">Set</span>
            <span className="header__optionline2">Yardages</span>
          </div>
        </Link>}
      </div>
    </nav>
  );
}

export default Header;
